import React from "react";

export function VersionIcon({ vectorEffect, style, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      style={{ ...style, height: "100%", overflow: "visible" }}
    >
      <path
        d="M7 3C7 2.44772 7.44772 2 8 2H11.5858C11.851 2 12.1054 2.10536 12.2929 2.29289L14.7071 4.70711C14.8946 4.89464 15 5.149 15 5.41421V13C15 13.5523 14.5523 14 14 14H8C7.44772 14 7 13.5523 7 13V3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
      <path
        d="M1 4V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M4 3V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M11 2V5.5C11 5.77614 11.2239 6 11.5 6H15"
        stroke="currentColor"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
